import React, { ChangeEvent, FormEvent, useRef } from 'react';
import { Grid } from '@mui/material';
import { AlertInfoSendComment } from '../../common/AlertInfoSendComment';
import { AlertInfoFileTypeInComment } from '../../common/AlertInfoFileTypeInComment';

type DivPropsType = {
  myCommetText: string
  setHtml: (html: string) => void
  addFileToComment: (event: ChangeEvent<HTMLInputElement>) => void
  sendComment: () => void
}

export const ContentEditable = React.memo((props: DivPropsType) => {
  const state = useRef({ value: props.myCommetText, prevValue: 'x' })

  if (state.current.prevValue !== props.myCommetText) {
    state.current.value = props.myCommetText
  }

  const handleInput = (event: FormEvent<HTMLDivElement>) => {

    const htmlNew = event.currentTarget.innerHTML
    state.current.prevValue = htmlNew
    props.setHtml(htmlNew)
  }
  const sendComment = () => {
    if (props.myCommetText === '' || props.myCommetText === undefined) {
      alert("You can't send empy comment!")
      return
    } else {
      props.sendComment()
    }
  }

  return (
    <>
      <Grid xs={12} item  id='divInComment'>
        <div data-placeholder='Add a comment .... '
         
          className='area'
          role="textbox"
          contentEditable={true}
          dangerouslySetInnerHTML={{ __html: state.current.value }}
          onInput={handleInput}
        ></div>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <AlertInfoFileTypeInComment addFileToComment={props.addFileToComment} text="Valid file types are:  jpg, jpeg, png, bmp, gif." />
        <AlertInfoSendComment title={'Send comment'} text="You can't send empy comment!" isOpen={props.myCommetText === '' || props.myCommetText === undefined} sendComment={sendComment} />
      </Grid>
    </>
  )
})
